/**
 * thời gian thực hiện
 */
export default {
  Annualy: 0,
  Stage:1,
};
